import type { VenueSummary } from './api'

/**
 * Match a venue directory against a guest's free-text query.
 *
 * A guest searching for where they are may type the venue's name, the street
 * they are standing on, or the venue code printed on the counter sign. All
 * three match. An empty query lists everything.
 */
export function filterVenues(venues: VenueSummary[], query: string): VenueSummary[] {
  const q = query.trim().toLowerCase()
  if (!q) return venues
  return venues.filter((venue) =>
    [venue.name, venue.address ?? '', venue.slug].some((field) => field.toLowerCase().includes(q)),
  )
}
